  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5" >
    <v-row no-gutters>
      <v-col >

      <div class="container">
    <line-chart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"/>
  </div>

      </v-col>

    </v-row>
  </v-container>
</template>

 </div>
</template>

<script>

import LineChart from '../../../components/Area.vue'
export default {
  name: 'LineChartContainer',
  components: { LineChart },
  data: () => ({
    loaded: false,
    chartdata: {
      labels: ['10 classe', '11 classe', '12 classe', '13 classe'],
      datasets: [
        {
          // label: ['red', 'blue' ],

          // Color: ['red', 'blue' ],
          borderColor: ['red', 'Purple', 'Green', 'yellow'],

          backgroundColor: ['red', 'Purple', 'Green', 'yellow'],
          data: [0, 513, 231, 183]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  async mounted () {
    this.loaded = false
    try {
    //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
